module.exports = __webpack_public_path__ + "img/google-app-photo.641b6778.webp";